import { useEffect, useState } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";

function CheckoutPage() {

    const [cartItems, setCartItems] = useState([])
    const [selectedAddress, setSelectedAddress] = useState(null)
    const [placingOrder, setPlacingOrder] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        fetchSelectedAddress();
        fetchCart();
    }, []);

    const fetchSelectedAddress = async () => {
        try {
            const res = await API.get("/api/address/selected")
            setSelectedAddress(res.data)
        } catch (error) {
            console.log(error)
        }
    };

    const fetchCart = async () => {
        try {
            const res = await API.get("/api/cart")
            setCartItems(res.data)
        } catch (error) {
            console.log(error)
        }
    }

    const total = cartItems.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
    );

    const handlePlaceOrder = async () => {
        try {

            if (placingOrder) return;

            setPlacingOrder(true);
            //Step 1 : Create Order

            const orderResponse = await API.post("/api/order", {
                addressId: selectedAddress.addressId,
                paymentMethod: "ONLINE"
            })
            console.log("Order Response:", orderResponse.data);

            const orderId = orderResponse.data.id;

            //Step 2 : Create Razorpay Order

            const paymentResponse = await API.post("/api/payment/create-order", {
                orderId: orderId
            })

            console.log("Payment Response:", paymentResponse.data);
            openRazorPay(paymentResponse.data)
        } catch (error) {
            console.log(error)
            setPlacingOrder(false)
            alert("Unable to place order")
        }
    }

    const openRazorPay = (paymentData) => {
        const options = {

            key: paymentData.key,

            amount: paymentData.amount,

            currency: paymentData.currency,

            order_id: paymentData.razorpayOrderId,

            name: "ShopSphere",

            description: "Order Payment",

            handler: async function (response) {

                await verifyPayment(response);

            },

            theme: {

                color: "#2874f0"

            }

        };

        const razorpay = new window.Razorpay(options)
        razorpay.open()

    }

    const verifyPayment = async (response) => {

        try {

            await API.post("/api/payment/verify", {

                razorpayOrderId: response.razorpay_order_id,

                razorpayPaymentId: response.razorpay_payment_id,

                razorpaySignature: response.razorpay_signature

            });

            alert("Payment Successful");

            navigate("/orders");

        } catch (error) {

            console.error(error);

            alert("Payment verification failed.");

        }


    };

    return (
        <div className="container mt-4">
            <div className="row">

                <div className="col-md-8">

                    <div className="card mb-3 shadow-sm">
                        <div className="card-body d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-2">Delivery Address</h5>

                                {selectedAddress ? (
                                    <>
                                        <p className="mb-1 fw-bold">
                                            {selectedAddress.user}
                                        </p>
                                        <p className="mb-0 text-muted">
                                            {selectedAddress.addressLine}, {selectedAddress.street}, {selectedAddress.city}, {selectedAddress.state} - {selectedAddress.pincode}
                                        </p>
                                    </>
                                ) : (
                                    <p className="text-danger">No address selected</p>
                                )}
                            </div>

                            <button
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => navigate("/choose-location", { state: { from: "checkout" } })}
                            >
                                Change
                            </button>
                        </div>
                    </div>

                    <div className="card shadow-sm">
                        <div className="card-body">
                            <h5 className="mb-3">Order Summary</h5>

                            {cartItems.length === 0 ? (
                                <p>Cart is empty</p>
                            ) : (
                                cartItems.map((item) => (
                                    <div
                                        key={item.cartId}
                                        className="d-flex border-bottom py-3 align-items-center"
                                    >

                                        <div style={{ width: "240px" }}>
                                            <img
                                                src={item.imageUrl}
                                                alt={item.productName}
                                                className="img-fluid rounded shadow-sm"
                                            />
                                        </div>

                                        <div className="ms-3 flex-grow-1">

                                            <h6>{item.productName}</h6>

                                            <p className="mb-1">
                                                Qty: {item.quantity}
                                            </p>

                                            <div>
                                                <span className="fw-bold">
                                                    ₹{item.price * item.quantity}
                                                </span>

                                                <small className="text-muted ms-2">
                                                    ₹{item.price} each
                                                </small>
                                            </div>

                                        </div>

                                    </div>
                                ))
                            )}

                        </div>
                    </div>

                </div>

                <div className="col-md-4">

                    <div className="card shadow-sm">
                        <div className="card-body">

                            <h5 className="mb-3">Price Details</h5>

                            <div className="d-flex justify-content-between">
                                <span>Price ({cartItems.length} items)</span>
                                <span>₹{total}</span>
                            </div>

                            <div className="d-flex justify-content-between text-success">
                                <span>Delivery</span>
                                <span>FREE</span>
                            </div>

                            <hr />

                            <div className="d-flex justify-content-between fw-bold">
                                <span>Total Amount</span>
                                <span>₹{total}</span>
                            </div>

                            <button
                                className="btn btn-primary w-100 mt-3"
                                onClick={handlePlaceOrder}
                                disabled={placingOrder || !selectedAddress || cartItems.length === 0}
                            >
                                {placingOrder ? "Processing..." : "Place Order"}
                            </button>

                        </div>
                    </div>

                </div>

            </div>
        </div>
    );


}

export default CheckoutPage;